module.exports = __webpack_public_path__ + "static/media/plus.54d2bc2b.svg";